import { Route, Routes as RouterRoutes, useMatch } from "react-router-dom";
import {
  HomeIcon,
  DocumentTextIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";
import { NavBar } from "../../components/ui";
import { Portal } from "../../util";
import * as Sentry from "@sentry/react";
import AuthRoute from "../../components/AuthRoute";
import useUser, { USER_ROLES } from "../../hooks/useUser";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";

import Analytics from "./pages/Analytics";
import Dashboard from "./pages/Dashboard";
import Wizard from "./pages/Wizard";
import Usage from "./pages/Usage";

const routes = [
  {
    path: "usage",
    element: Usage,
    permissions: ["EMAIL_MODULE"],
  },
  {
    path: ":id/analytics",
    element: Analytics,
    permissions: ["EMAIL_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["EMAIL_MODULE"],
  },
  {
    path: "*",
    element: Dashboard,
    permissions: ["READ_MAILING_LIST", "EMAIL_MODULE"],
  },
];

const Email = props => {
  const { hasRole } = useUser({ withRoles: true });
  const isAdministrator =
    hasRole(USER_ROLES.ADMIN) || hasRole(USER_ROLES.SUPER_ADMIN);
  const usageMatch = useMatch("/email/usage");
  const match = useMatch("/email/:id/*");
  const id = match?.params?.id === "usage" ? null : match?.params?.id;
  const navigation = [
    { href: "/email", icon: HomeIcon, name: "Emails" },
    ...(isAdministrator
      ? [{ href: "/email/usage", icon: ChartBarIcon, name: "Usage" }]
      : []),
    ...(id
      ? [
          {
            href: `/email/${id}/content`,
            icon: DocumentTextIcon,
            name: "Details",
          },
        ]
      : []),
  ];
  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary("email")}
      beforeCapture={scope => {
        scope.setTag("module", "email");
      }}
    >
      <Portal id="sidebar">
        <NavBar
          navigation={navigation}
          open={props?.open}
          path={
            usageMatch
              ? ["/email/usage"]
              : id
                ? [`/email/${id}/content`]
                : ["/email"]
          }
        />
      </Portal>
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

export default Email;
